export default {
  general: {
    primaryColor: '#204E80',
    secondaryColor: '#42424f',
  },
  login: {
    backgroundColor: '#ffffff',
    logo: {
      width: 200,
      height: 'auto',
    },
    form: {
      textColor: '#969696',
      labelColor: '#FFFFFF',
      borderColor: '#969696',
      buttonTextColor: '#fff',
    },
  },
  menu: {
    backgroundColor: '#193B60',
    logo: {
      width: 'auto',
      height: 135,
    },
    header: {
      borderColor: '#3d3d58',
      // backgroundColor: '#ffffff',
      // You can add any css here
      paddingBottom: 0,
      paddingTop: 10,
      margin: 10
    },
    items: {
      textColor: '#b0b0b0',
      iconColor: '#9898A2',
      activeIconColor: '#FFFFFF',
      activeBackgroundColor: '#2BABE2',
      activeTextColor: '#FFFFFF',
      subHeaderColor: '#fff',
    },
  },
};
